(function () {
  'use strict';

  var section = document.querySelector('[data-luxe-walk]');
  if (!section) return;

  var steps = Array.prototype.slice.call(section.querySelectorAll('.luxe-walk__step'));
  var imgs = Array.prototype.slice.call(section.querySelectorAll('.luxe-walk__img'));
  var n = steps.length;
  if (n === 0) return;

  var cur = -1;
  function setActive(i) {
    if (i === cur) return;
    cur = i;
    for (var j = 0; j < n; j++) {
      var on = j === i;
      steps[j].classList.toggle('is-active', on);
      if (imgs[j]) imgs[j].classList.toggle('is-active', on);
    }
  }

  function activeFromProgress(p) {
    var i = Math.floor(p * n);
    if (i < 0) i = 0;
    if (i > n - 1) i = n - 1;
    setActive(i);
  }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var gsap = window.gsap;
  var ST = window.ScrollTrigger;
  var mobile = window.matchMedia('(max-width: 800px)').matches;

  if (reduce || !gsap || !ST) {
    section.classList.add('no-anim');
    return;
  }

  gsap.registerPlugin(ST);

  var SNAP_POINTS = [];
  for (var si = 0; si < n; si++) SNAP_POINTS.push((si + 0.5) / n);

  var SNAP = {
    snapTo: SNAP_POINTS,
    duration: { min: 0.2, max: 0.5 },
    delay: 0.06,
    ease: 'power2.inOut',
    inertia: false,
    directional: false
  };

  // How much scroll each step is given on mobile, in viewport heights.
  // Desktop takes its length from CSS instead (--walk-steps * 100vh, see
  // luxe-walk.css); on mobile that rule is height:auto and ScrollTrigger pins
  // the sticky panel over a distance it sets itself — so this is the only
  // knob for how long the mobile walkthrough runs.
  var MOBILE_STEP_VH = 0.5;

  if (mobile) {
    var sticky = section.querySelector('[data-walk-sticky]') || section;
    ST.create({
      trigger: sticky,
      start: 'top top',
      end: function () { return '+=' + (window.innerHeight * n * MOBILE_STEP_VH); },
      pin: sticky,
      pinSpacing: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      snap: SNAP,
      onUpdate: function (self) { activeFromProgress(self.progress); }
    });
    ST.refresh();
    return;
  }

  ST.create({
    trigger: section,
    start: 'top top',
    end: 'bottom bottom',
    snap: SNAP,
    onUpdate: function (self) { activeFromProgress(self.progress); }
  });

  ST.refresh();
})();
